import React, { Component } from 'react'
import '../../scss/print.scss'
import ReactToPrint from 'react-to-print'
import ManualDescription from './ManualDescription'

class ManualPrint extends Component {

  render() {
    return (
      <div>
        <ReactToPrint
          trigger={() => <button id="print-manual" className="downloadBtn">
            <i className="fa fa-cloud-download fa-lg" /> Print this!</button>
          }
          content={() => this.componentRef}
          copyStyles={() =>  <link rel="stylesheet" type="text/css" href="print.css" />}
        />
        <ManualDescription ref={el => (this.componentRef = el)} />
      </div>
    )
  }
}
export default ManualPrint



// WEBPACK FOOTER //
// ./src/components/Manual/ManualPrint.js